<template>
  <div>
    <h1>クラウド</h1>
    <p>potlyをGoogle IDと連携すると、データをGoogle Driveにバックアップ・リストアすることができます。</p>
    <div v-if="checking">
      <p>checking...</p>
    </div>
    <div v-else>
      <div v-if="isGdSignin">
        <h2>バックアップステータス</h2>
        <p class="text-lg">
          <span v-if="newer === 1">ローカルデータが新しいです</span>
          <span v-else>クラウドデータが新しいです</span>
        </p>
        <p>Google Drive上の最新バックアップ: <strong>{{fileStat.modifiedTime | dayformat}}</strong></p>
        <p>ローカルの最新更新: <strong>{{localLastUpdate | dayformat}}</strong></p>
        <p>{{message}}</p>
        <p v-if="newer === 1">
          <button class="btn" @click="gdUpload">
            <span class="text-lg"><font-awesome-icon icon="cloud-upload-alt" /></span>
            Google Driveにバックアップ
          </button>
        </p>
        <p v-else>
          <button class="btn reverse" @click="gdDownload">
            <span class="text-lg"><font-awesome-icon icon="cloud-download-alt" /></span>
            Google Driveから復元
          </button>
        </p>

        <h2>バックアップする</h2>
        <p>
          <button class="btn" @click="gdUpload">
            <span class=""><font-awesome-icon icon="cloud-upload-alt" /></span>
            Google Driveにバックアップ
          </button>
        </p>
        <h2>復元する</h2>
        <p>
          <button class="btn reverse" @click="gdDownload">
            <span class=""><font-awesome-icon icon="cloud-download-alt" /></span>
            Google Driveから復元
          </button>
        </p>
        <h2>サインアウト</h2>
        <p>
          <button class="btn" @click="gdSiginOut">Google サインアウト</button>
        </p>
      </div>
      <div v-else>
        <h2>Login</h2>
        <p>
          <button class="btn" @click="gdSiginIn">Google サインイン</button>
        </p>
      </div>
    </div>
    <p
      class="notice__txt"
    >potlyはGoogle Driveに「potly専用領域」を作成し、「potly専用領域」の中でだけデータを操作します。「potly専用領域」は削除はできますが、ユーザーが操作することはできません。</p>
    <p
      class="notice__txt"
    >potlyは「potly専用領域」以外のGoogle Driveユーザーデータの全てを閲覧・操作しない（権限が付与されない）ので、安心してご利用いただけます。</p>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'Cloud',
  data() {
    return {
      checking: true,
      message: "",
      newer: null
    };
  },
  async created() {
    this.init();
  },
  mounted() {
    // this.compareData();
  },
  methods: {
    init: async function() {
      await this.gdApiInit();
      await this.setLocalLastUpdate();
      if (this.isGdSignin) {
        await this.setCloudDataset();
      }
      this.compareData();
      this.checking = false;
    },
    compareData(){
      // 厳密な計算はできない
      const local = dayjs(this.localLastUpdate).valueOf();
      const cloud = dayjs(this.fileStat.modifiedTime).valueOf();
      if(cloud === local){
        this.newer = 0
      }else{
        if(local > cloud){
          this.newer = 1
        }else{
          this.newer = 2
        }
      }
    }
  }
};
</script>
